









import { Component, Prop, State, Vue } from 'nuxt-property-decorator';
import ClientSettings from '../../store/clientSettings.store';
import LocalConfigStore from '@/store/localConfig.store';
import ThemeStore from '@/store/theme.store';
import { Page } from '@/types/pageContract';
import { Site } from '@/types/initialData';

@Component({})
export default class HeaderOffsetSpacer extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.page?.page)
  page: Page;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  @Prop({ type: Number, default: 0 })
  manualSpacingHeightVal!: number;

  spacingHeightVal: number = 70;
  spacingHeightDesktopVal: number = 64;
  spacingAppIsScrolledVal: number = 48;
  spacingAppIsScrolledDesktopVal: number = 48;

  get pageIsDiscontinued(): boolean {
    return (
      !LocalConfigStore.discontinuedBannerHidden &&
      this.page &&
      this.page.discontinued
    );
  }

  get siteIsUnderConstruction(): boolean {
    return (
      !LocalConfigStore.underConstructionBannerHidden &&
      this.page &&
      this.page.discontinued === undefined &&
      this.page?.pageSettings?.messages.underConstruction &&
      !ThemeStore.appIsScrolled
    );
  }

  get spacingHeight(): number {
    let heightVal;

    if (ThemeStore.appIsScrolled) {
      heightVal = this.currentHeightIsScrolledVal;
    } else {
      heightVal = this.currentHeightVal;
    }

    if (ClientSettings.focusMode) {
      heightVal = 0;
    }

    if (
      LocalConfigStore.backendUserActive &&
      !this.pageIsDiscontinued &&
      !this.siteIsUnderConstruction
    ) {
      heightVal = this.currentHeightVal * 2;
    }

    if (this.siteIsUnderConstruction) {
      if (LocalConfigStore.backendUserActive) {
        heightVal = this.currentHeightVal * 3;
      } else {
        heightVal = this.currentHeightVal * 2;
      }
    }
    if (this.pageIsDiscontinued) {
      if (LocalConfigStore.backendUserActive) {
        heightVal = this.currentHeightVal * 3;
      } else {
        heightVal = this.currentHeightVal * 1.5;
      }
      if (ThemeStore.appIsScrolled) {
        heightVal = this.currentHeightIsScrolledVal * 1.5;
      }
    }

    return this.manualSpacingHeightVal > 0
      ? this.manualSpacingHeightVal
      : heightVal;
  }

  get currentHeightVal(): number {
    return this.$vuetify.breakpoint.mdAndUp
      ? this.spacingHeightDesktopVal
      : this.spacingHeightVal;
  }

  get currentHeightIsScrolledVal(): number {
    return this.$vuetify.breakpoint.mdAndUp
      ? this.spacingAppIsScrolledDesktopVal
      : this.spacingAppIsScrolledVal;
  }
}
